import { gql } from '@apollo/client';

// Query: List institution admins + pending invitations
export const GET_INSTITUTION_ADMINS = gql`
  query GetInstitutionAdmins($organizationId: ID!) {
    institutionAdmins(organizationId: $organizationId) {
      id
      email
      firstName
      lastName
      name
      phone
      status
      role
      lastUpdatedAt
      invitedAt
    }
  }
`;

// Mutation: Invite a new institution admin
export const INVITE_INSTITUTION_ADMIN = gql`
  mutation InviteInstitutionAdmin($organizationId: ID!, $input: InviteAdminInput!) {
    inviteInstitutionAdmin(organizationId: $organizationId, input: $input) {
      id
      orgId
      email
      firstName
      lastName
      phone
      status
      invitedAt
      expiresAt
    }
  }
`;

// Mutation: Resend invitation email
export const RESEND_INVITATION = gql`
  mutation ResendInvitation($invitationId: ID!) {
    resendInstitutionAdminInvitation(invitationId: $invitationId) {
      id
      status
      expiresAt
    }
  }
`;

// Mutation: Revoke a pending invitation
export const REVOKE_INVITATION = gql`
  mutation RevokeInvitation($invitationId: ID!) {
    revokeInstitutionAdminInvitation(invitationId: $invitationId)
  }
`;
